import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

@Pipe({
  name: 'accountingCurrency'
})
export class AccountingCurrencyPipe implements PipeTransform {
  constructor(private currencyPipe: CurrencyPipe) {}

  transform(
    value: number | string | null | undefined,
    showSymbol: boolean = true,
    currencyCode?: string,
    digitsInfo?: string,
    locale?: string
  ): string | null {
    if (value === null || value === undefined) {
      return null;
    }
    const numericValue = typeof value === 'string' ? parseFloat(value) : value;

    if (isNaN(numericValue)) {
      return null;
    }

    const absoluteValue = Math.abs(numericValue);
    const display = showSymbol ? 'symbol' : '';
    const formatted = this.currencyPipe.transform(absoluteValue, currencyCode, display, digitsInfo, locale);
    if (formatted === null || formatted === undefined) {
      return null;
    }

    // Wrap in parentheses if negative value
    return numericValue < 0 ? `(${formatted})` : formatted;
  }
}
